// extracted by mini-css-extract-plugin
export default {"header":"style_header__Uz7OB","header_title":"style_header_title__ivYtb"};